import React, { useCallback, useContext, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import { Button, CircularProgress, TextField } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
// import DateTimePicker from 'react-datetime-picker';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useHistory } from 'react-router';
import './JoinShortCode.css';
import * as ORIGINAL_HREF from '../../../constants/originalHref';

function JoinShortCode() {
	const { firebase } = useContext(FirebaseContext);
	const history = useHistory();
	const [alert, setAlert] = useState('');
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	var currentShortCode;

	console.log(
		'New shortcode to add we must now find ' +
			ORIGINAL_HREF.originalHREF.splitHref
	);
	if (ORIGINAL_HREF.originalHREF.splitHref != null) {
		if (ORIGINAL_HREF.originalHREF.splitHref.includes('linkid')) {
			var split1 = ORIGINAL_HREF.originalHREF.splitHref.split('=');
			var split2 = split1[1].split('_split_');
			var thisCode = split2[0];
			console.log('CURRENT LONG CODE ' + thisCode);
			currentShortCode = thisCode;
			//GetShortFromLong(thisCode);
		}
	}

	const FindMeetingFromShortCode = async (shortCode) => {
		var longCode;

		await firebase
			.database()
			.ref('short_code_list')
			.child(shortCode)
			.once('value', (snapshot) => {
				longCode = snapshot.val()?.longCode;
			});

		console.log('long code ' + longCode);

		return longCode;
	};

	const GoToMeeting = async (shortCode) => {
		try {
			console.log('Testing short code : ' + shortCode);

			var newLongCode = await FindMeetingFromShortCode(shortCode);

			console.log('Long code ' + newLongCode);

			if (!newLongCode) {
				throw 'The short code is invalid';
			}

			var appointmentGet = firebase
				.database()
				.ref('client_appointments')
				.child(PROJECT_CODE.projectCode)
				.child(newLongCode);

			var appointmentData = {};

			var currentUserId = firebase.auth().currentUser.uid;

			var userRef = firebase.database().ref('users').child(currentUserId);

			var myUser;

			await userRef.once('value', (snapshot) => {
				myUser = snapshot.val();
			});

			await appointmentGet.once('value', (snapshot) => {
				console.log('got long code ' + snapshot.val().createrID);
				//handleVideoCall(snapshot.val());

				appointmentData['apptime'] = snapshot.val().timeOfAppointment;
				appointmentData['appointmentID'] = snapshot.val().appointmentID;
				appointmentData['name'] = myUser.fullName;
				appointmentData['email'] = myUser.email;
				appointmentData['appnumber'] = myUser.phoneNumber;
				appointmentData['shortCode'] = shortCode;
				//appointmentData['name']
			});

			handleVideoCall(appointmentData, myUser.userType);
			// var appointmentPost = await firebase
			// 	.database()
			// 	.ref('/client_appointments/' + PROJECT_CODE.projectCode)
			// 	.push();
		} catch (error) {
			console.log(error);
			setAlert('Please enter a valid shortcode.');
			setTimeout(() => setAlert(''), 3000);
		}
	};

	const handleVideoCall = (dataset, userType) => {
		setLoading(true);
		console.log('Go to video c');
		let currentTimeDate = Date.now();
		var timeIn5Min = currentTimeDate + 300000;
		var time30MinAgo = currentTimeDate - 1800000;

		var appEmail = dataset.email;
		var appName = dataset.name;
		var appCode = dataset.appointmentID;
		var appTime = dataset.apptime;
		var appNumber = dataset.appnumber;
		var thisShortCode = dataset.shortCode;
		var currentUserId = firebase.auth().currentUser.uid;
		var currentUserType = userType;

		if (appEmail === 'guest1kavtek@gmail.com') {
			var characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			var result = [];

			for (var i = 0; i < 5; i++) {
				result.push(
					characters.charAt(Math.floor(Math.random() * charactersLength))
				);
			}

			var joinedResult = result.join('');

			currentUserId = currentUserId + joinedResult;
		}

		if (appCode !== 'undefined' && timeIn5Min >= appTime) {
			var detailsForCall = {
				thisEmail: appEmail,
				thisName: appName,
				thisAppointmentCode: appCode,
				thisAppointmentTime: appTime,
				thisUserType: currentUserType,
				thisPhone: appNumber,
				thisUID: currentUserId,
				shortCode: thisShortCode,
			};

			console.log(
				'This is the details for appointment List to send videocall: ' +
					JSON.stringify(detailsForCall)
			);

			history.push({
				pathname: '/videocall',
				state: {
					detail: detailsForCall,
				},
			});
			setLoading(false);
		} else {
			if (appCode === 'undefined') {
				setAlert('No meetings registered to your account.');
				setTimeout(() => setAlert(''), 5000);
			} else if (timeIn5Min <= appTime) {
				setAlert(
					'Appointment not ready, the earliest you can join is 5 minutes before.'
				);
				setTimeout(() => setAlert(''), 5000);
			}
			setLoading(false);
		}
	};

	return (
		<div className='client-details shortcode_card'>
			{loading && (
				<div className='loading_layout_add_people'>
					<CircularProgress
						style={{ position: 'absolute', left: '50%', top: '15%' }}
					/>
				</div>
			)}
			{alert && <p className='form-alert'>{alert}</p>}
			<h1 className='card-header'>Join a video call</h1>
			<div className='form-group'>
				<TextField
					id='shortCodeEntry'
					type='text'
					label='Enter shortcode here'
					name='currentShortCode'
					value={currentShortCode}
					onChange={(e) => {
						currentShortCode = e.target.value;
						console.log('Code in : ' + e.target.value);
					}}
				/>
				<button
					onClick={() => {
						GoToMeeting(currentShortCode);
					}}
					className='shortcode_btn'
				>
					Enter Meeting Code
				</button>
			</div>
		</div>
	);
}

export default JoinShortCode;
